import React, { Component } from "react";
import { Form, Spinner, Image } from "react-bootstrap";
import { activeReport } from "../../../actions/mis.action";
import FilterComponent from "../../../component/filterComponent";
import { getLocalstorage, setLocalstorage } from "../../../helper";

class SearchInMis extends Component {
  debounce = null;
  constructor(props) {
    super(props);
    this.state = {
      searchValue: ""
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.activeReport !== this.props.activeReport) {
      this.setState({
        searchValue: ""
      });
    }
  }
  onSearch = event => {
    const { onChange } = this.props;
    const value = event.target.value.length > 0 ? event.target.value : "";
    this.setState({
      searchValue: value
    });
    onChange(value);
    this.onCallAfterDebounce(value);
  };

  onCallAfterDebounce = isSearchValueExist => {
    const { callAfterDebounce, debounceTime = 1000, keyName } = this.props;
    const { searchValue } = this.state;
    this.debounce && clearTimeout(this.debounce);
    const value =
      isSearchValueExist.length > 0 ? { name: keyName, searchValue } : false;
    this.debounce = setTimeout(() => {
      callAfterDebounce && callAfterDebounce(value);
    }, debounceTime);
  };

  filtersInFilterComponent = filterListInFilterComponent => {
    const { onSelectingFilter } = this.props;
    onSelectingFilter(filterListInFilterComponent);
  };

  getFilterId = (id, element) => {
    const { getFilterId } = this.props;
    getFilterId(id, element);
  };

  onOpenOfModal = (modalState, previousFilterCount, currentFilterCount) => {
    const { onOpenOfModal } = this.props;
    onOpenOfModal(modalState, previousFilterCount, currentFilterCount);
  };

  onOpenOfProjectSummaryModal = (
    projectModalState,
    previousFilterCount,
    currentFilterCount
  ) => {
    const { onOpenOfProjectSummaryModal } = this.props;
    onOpenOfProjectSummaryModal(
      projectModalState,
      previousFilterCount,
      currentFilterCount
    );
  };

  render() {
    const { props, onChange } = this;

    const {
      loader = true,
      classes = "",
      isLoading = false,
      isSearchingUsers,
      isSearchingBestPractice,
      isSearchingIssue,
      filterList,
      getFilterId,
      makeSelectedNull,
      isFromMisSection,
      activeReport,
      isGroupNameSearching
    } = props;
    return (
      <div
        className={`search-container-component ${classes}`}
        style={{
          marginRight: window.location.pathname == "/mis" ? "-15px" : "",
          width: window.location.pathname == "/mis" ? "330px" : ""
        }}
      >
        <Form.Control
          value={this.state.searchValue}
          {...props}
          type="text"
          className="search-field search-330"
          onChange={event => {
            this.onSearch(event);
          }}
        />
        {<span className="search-container-icon" />}
        {loader &&
        (isSearchingBestPractice === true ||
          isSearchingUsers === true ||
          isSearchingIssue === true ||
          isGroupNameSearching) ? (
          <div className="search-container-spinner">
            <FilterComponent
              filterList={filterList}
              getFilterId={getFilterId}
              makeSelectedNull={makeSelectedNull}
              isUserFilter={true}
              isFromMisSection={isFromMisSection}
              activeReport={activeReport}
              onSelectedFilter={this.filtersInFilterComponent}
              onOpenOfModal={this.onOpenOfModal}
              onOpenOfProjectSummaryModal={this.onOpenOfProjectSummaryModal}
            />
          </div>
        ) : (
          <div className="search-container-spinner">
            {isLoading ? (
              <Spinner animation="border" variant="secondary" />
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

export { SearchInMis };
